// extracted by mini-css-extract-plugin
module.exports = {"head":"Notifies_head_btNp0","actions":"Notifies_actions_19uDp","left":"Notifies_left_2EYBm","right":"Notifies_right_1-wSk"};